import { __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError, logFeature } from '@office-start/telemetry-service';
import { getRequestIdFromResponse, httpGet } from '@office-start/xhr-service';
import { clientRequestIdHeader, headerDiagnostics, localeParam, } from '../models/Constants';
import { getServerDebugInfoString } from '../utilities/getServerDebugInfoString';
import { createRequestConfig } from './createRequestConfig';
import { parseRecentResponse } from './parseRecentResponse';
import { parseSettings } from './parseSettings';
var fetchRequestIndex = 0;
export function fetchFavorites(apiOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var aadAppId, correlationId, edgeworthApiRootPath, getAccessToken, iceApplicationId, jwtAuthEnabled, objectId, officeHomeApiRoot, preferredCulture, favoritesApiPath, favoritesItemsCount, substrateApiEndpoint, tenantId, currentPage, requestId, endpoint, requestConfig;
        return __generator(this, function (_a) {
            aadAppId = apiOptions.aadAppId, correlationId = apiOptions.correlationId, edgeworthApiRootPath = apiOptions.edgeworthApiRootPath, getAccessToken = apiOptions.getAccessToken, iceApplicationId = apiOptions.iceApplicationId, jwtAuthEnabled = apiOptions.jwtAuthEnabled, objectId = apiOptions.objectId, officeHomeApiRoot = apiOptions.officeHomeApiRoot, preferredCulture = apiOptions.preferredCulture, favoritesApiPath = apiOptions.favoritesApiPath, favoritesItemsCount = apiOptions.favoritesItemsCount, substrateApiEndpoint = apiOptions.substrateApiEndpoint, tenantId = apiOptions.tenantId, currentPage = apiOptions.currentPage;
            requestId = createGuid();
            endpoint = "".concat(substrateApiEndpoint).concat(edgeworthApiRootPath).concat(favoritesApiPath, "?top=").concat(favoritesItemsCount, "&").concat(localeParam).concat(preferredCulture);
            requestConfig = createRequestConfig(objectId, tenantId, iceApplicationId, currentPage, aadAppId, requestId);
            return [2 /*return*/, httpGet(KnownInstrumentationEvents.EdgeworthSubstrateFavoritesRequest, "EdgeworthSubstrateFavorites" /* KnownRequestInstrumentationEvents.EdgeworthSubstrateFavoritesRequest */, endpoint, requestConfig, jwtAuthEnabled, getAccessToken, officeHomeApiRoot, correlationId, 'Substrate', {
                    populateRequestEvent: function (response, params) {
                        params["EventType" /* InstrumentationParam.EventType */] = 'Request';
                        params["RequestId" /* InstrumentationParam.RequestId */] =
                            getRequestIdFromResponse(response) || '';
                        params["DebugInfo" /* InstrumentationParam.DebugInfo */] =
                            getServerDebugInfoString(response);
                        params["Index" /* InstrumentationParam.Index */] =
                            (fetchRequestIndex++).toString();
                        params["ImpressionId" /* InstrumentationParam.ImpressionId */] =
                            (response.headers &&
                                response.headers[clientRequestIdHeader]) ||
                                requestId;
                        params["Diagnostics" /* InstrumentationParam.Diagnostics */] =
                            response.headers && response.headers[headerDiagnostics];
                        var featureParams = params;
                        logFeature({
                            featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
                            eventName: "EdgeworthSubstrateFavorites" /* KnownRequestInstrumentationEvents.EdgeworthSubstrateFavoritesRequest */,
                            params: featureParams,
                        });
                        delete params["EventType" /* InstrumentationParam.EventType */];
                    },
                })
                    .then(function (response) {
                    if (!response || !response.data) {
                        logError({
                            eventName: 'FetchFavoritesError',
                            errorType: 'Invalid_Response',
                        });
                        throw new Error('Invalid favorites response data');
                    }
                    return {
                        settings: parseSettings(response.data),
                        data: parseRecentResponse(response.data),
                        impressionId: (response.headers &&
                            response.headers[clientRequestIdHeader]) ||
                            requestId,
                    };
                })
                    .catch(function (error) {
                    getErrorHandler().handleError(error, "Bn3rc" /* ErrorId.Bn3rc */);
                    throw error;
                })];
        });
    });
}
//# sourceMappingURL=fetchFavorites.js.map